import type { PropsWithChildren } from "react";
import React, { memo } from "react";
import type { RadioVariants } from "./Radio.styles";
import RadioVariant, { InputWrapper } from "./Radio.styles";
import Icon from "../Icon";

export type RadioVariantsType = keyof typeof RadioVariants;

export type RadioType = {
    checked: boolean;
    variant: RadioVariantsType;
    position?: "left" | "right";
    id: string;
    title?: string;
    disabled?: boolean;
    onClick?: () => void;
};

const Radio: React.FC<PropsWithChildren<RadioType>> = (props) => {
    const { checked, variant, id, title, position = "left", disabled, onClick, children } = props;
    return (
        <RadioVariant variant={variant}>
            {position === "left" && (
                <InputWrapper isChecked={checked} isDisabled={disabled}>
                    <input id={id} type="radio" title={title} disabled={disabled} checked={checked} onClick={onClick} />
                    <Icon variant="check" />
                </InputWrapper>
            )}
            <label htmlFor={id} tabIndex={0}>
                {children}
            </label>
            {position === "right" && (
                <InputWrapper isChecked={checked} isDisabled={disabled}>
                    <input id={id} type="radio" title={title} disabled={disabled} checked={checked} onClick={onClick} />
                    <Icon variant="check" />
                </InputWrapper>
            )}
        </RadioVariant>
    );
};

export default memo(Radio);
